import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var pkategoriService = {
    pkategoriTanimlama(link, baslik, seoBaslik, seoIcerik) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                link: link,
                baslik: baslik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                serviceName: "partner",
                methodName: "pkategoriTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pKategoriDetay(pkategoriId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                pkategoriId: pkategoriId,
                serviceName: "partner",
                methodName: "kategoriDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pkategoriList(durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                durum: durum,
                serviceName: "partner",
                methodName: "pkategoriList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pkategoriDurumGuncelle(pkategoriId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                pkategoriId: pkategoriId,
                durum: durum,
                serviceName: "partner",
                methodName: "pkategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pkategoriGuncelle(pkategoriId, link, baslik) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                pkategoriId : pkategoriId,
                link: link,
                baslik: baslik,
                serviceName: "partner",
                methodName: "pkategoriGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default pkategoriService

